import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber, FormattedMessage } from 'react-intl';
import { isObjEmpty } from 'utils/varValidation';

// Components
import { Row, Col } from 'reactstrap';
import { Icon } from 'components/atoms/Icon/';
import VehicleImageWithPlaceholder from 'components/atoms/VehicleImageWithPlaceholder';

// Constants
import { SERVICES_ROUTE, DECLINED_SERVICES_ROUTE } from 'constants/routes';
import { NAVIGATION } from 'constants/navigations';
import { SEARCH_CRITERIA_FIND_ME } from 'constants/findMe';

// Utils
import { getVehicleImgUrl } from 'utils/media';
import { clickEvent } from 'utils/adaConfigurations/customEvents';

import './CustomerVehicle.scss';

const ns = 'customer-vehicle';
const { FORWARD } = NAVIGATION;
const { EMAIL, LICENSE_NUMBER } = SEARCH_CRITERIA_FIND_ME;

class CustomerVehicle extends Component {
  constructor(props, context) {
    super(props, context);
    this.clickHandler = this.clickHandler.bind(this);
  }

  async clickHandler(ev, carData) {
    const {
      carData: { personId },
      setEmail,
      setPhoneNumber,
      setMobilePhoneNumber,
      setCustomerVehicle,
      setLoginData,
      setObfuscatedBy,
      setFirstName,
      setLastName,
      searchCriteriaFindMe
    } = this.props;
    const {
      mileageDt,
      lastname,
      firstname,
      phoneNumber,
      mobileNumber,
      email,
      ...vehicle
    } = carData;

    const person = {
      email,
      lastname,
      firstname,
      phoneNumber,
      mobileNumber
    };

    ev.stopPropagation();
    if (!isObjEmpty(person)) {
      setObfuscatedBy(searchCriteriaFindMe);
      setFirstName(person.firstname);
      setLastName(person.lastname);
    }
    if (searchCriteriaFindMe === EMAIL) {
      if (!isObjEmpty(person)) {
        setPhoneNumber(person.phoneNumber || person.mobileNumber);
      }
    } else if (searchCriteriaFindMe === LICENSE_NUMBER) {
      if (!isObjEmpty(person)) {
        setPhoneNumber(person.phoneNumber || person.mobileNumber);
        setEmail(person.email);
      }
    } else {
      if (!isObjEmpty(person)) {
        setEmail(person.email);
      }
    }
    if (person.mobileNumber) {
      setMobilePhoneNumber(person.mobileNumber);
    }
    setLoginData({ personId });
    await setCustomerVehicle(vehicle);
    this.redirect();
  }

  redirect() {
    const { declinedServices, deferredServices, goTo } = this.props;
    const route =
      declinedServices.length + deferredServices.length > 0
        ? DECLINED_SERVICES_ROUTE
        : SERVICES_ROUTE;
    goTo(route, FORWARD);
  }

  render() {
    const {
      carData,
      carData: { make, year, model, mileage },
      dealerCountryCode,
      gtmUserEvent,
      showMileage,
      intl
    } = this.props;
    return (
      <div
        className={ns}
        onClick={ev => {
          this.clickHandler(ev, carData);
          gtmUserEvent(
            'Vehicle',
            'Clicked',
            'Vehicle Selected',
            'GTM_CURRENT_PAGE > Schedule Your Service Section > Choose Vehicle',
            [make, year, model].join('-')
          );
        }}
        onKeyUp={clickEvent}
      >
        <Row className="no-gutters">
          <Col xs={'4'} sm={'3'}>
            <VehicleImageWithPlaceholder
              src={getVehicleImgUrl(carData, dealerCountryCode)}
            />
          </Col>
          <Col className={`${ns}__car-data`} xs={'6'} sm={'8'}>
            <div className={`${ns}__name`}>
              {year} {make} {model}
            </div>
            {mileage > 0 &&
              showMileage && (
                <div className={`${ns}__mileage`}>
                  <FormattedMessage
                    id="c8.start.page.modal.estimated.mileage"
                    values={{
                      mileage: <FormattedNumber value={mileage} />
                    }}
                  />
                </div>
              )}
          </Col>
          <Col className={`${ns}__nav-next ${ns}--image`} xs={'2'} sm={'1'}>
            <Icon
              type="chevron__right"
              tabIndex={0}
              aria-label={intl.formatMessage({
                id: 'c8.aria.select.vehicle',
                defaultMessage: `Select ${year} ${make} ${model}`
              })}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

CustomerVehicle.propTypes = {
  carData: PropTypes.object.isRequired,
  dealerCountryCode: PropTypes.string.isRequired,
  declinedServices: PropTypes.array.isRequired,
  deferredServices: PropTypes.array.isRequired,
  goTo: PropTypes.func.isRequired,
  gtmUserEvent: PropTypes.func,
  searchCriteriaFindMe: PropTypes.string.isRequired,
  setCustomerVehicle: PropTypes.func.isRequired,
  setEmail: PropTypes.func.isRequired,
  setFirstName: PropTypes.func.isRequired,
  setLastName: PropTypes.func.isRequired,
  setObfuscatedBy: PropTypes.func.isRequired,
  setPhoneNumber: PropTypes.func.isRequired,
  showMileage: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired
};

export default CustomerVehicle;



// WEBPACK FOOTER //
// ./src/components/atoms/CustomerVehicle/CustomerVehicle.js